// Dataset for "내가 쓴 댓글" (My Comments)
export const myCommentsData = {
  title: '내가 쓴 댓글',
  count: '100',
  icon: 'PenLine',
  navigationRoute: '/naver/callmetellme/mypage/my-comments',
  postsData: [
    {
      id: 1,
      content: '"저도 비슷한 경험 있는데 그거 서류 준비할때 면접관님이랑..."',
      timeAgo: '1일 전',
      description: '답글 2',
      pillText: '댓글',
      pillColor: '#ECEEF4',
      pillTextColor: '#8789A2',
    },
    {
      id: 2,
      content: '"저도 비슷한 경험 있는데 그거 서류 준비할때 면접관님이랑..."',
      timeAgo: '1일 전',
      description: '답글 2',
      pillText: '댓글',
      pillColor: '#ECEEF4',
      pillTextColor: '#8789A2',
    },
  ],
};

// Dataset for "내 댓글에 답글" (Replies to My Comments)
export const repliesToMyCommentsData = {
  title: '내 댓글에 답글',
  count: '1490',
  icon: 'PenLine',
  navigationRoute: '/naver/callmetellme/mypage/replies-to-my-comments',
  postsData: [
    {
      id: 1,
      content:
        '"정말 유용한 후기네요! 혹시 더 자세한 내용 알려주실 수 있나요?"',
      timeAgo: '3일 전',
      description: '내 댓글에 대한 답글',
      pillText: '새 댓글',
      pillColor: '#ABD4F6',
      pillTextColor: '#3F68FF',
    },
    {
      id: 2,
      content:
        '"정말 유용한 후기네요! 혹시 더 자세한 내용 알려주실 수 있나요?"',
      timeAgo: '1주 전',
      description: '내 댓글에 대한 답글',
      pillText: '댓글',
      pillColor: '#ECEEF4',
      pillTextColor: '#8789A2',
    },
  ],
};

// Dataset for "내 게시글에 달린 댓글" (Comments on My Posts)
export const commentsOnMyPostsData = {
  title: '내 게시글에 달린 댓글',
  count: '57',
  icon: 'PenLine',
  navigationRoute: '/naver/callmetellme/mypage/comments-on-my-posts',
  postsData: [
    {
      id: 1,
      content:
        '"정말 유용한 후기네요! 혹시 더 자세한 내용 알려주실 수 있나요?"',
      timeAgo: '3일 전',
      description: '내 글 : 스타트업 사업후기 !!',
      pillText: '새 댓글',
      pillColor: '#ABD4F6',
      pillTextColor: '#3F68FF',
    },
    {
      id: 2,
      content:
        '"정말 유용한 후기네요! 혹시 더 자세한 내용 알려주실 수 있나요?"',
      timeAgo: '1주 전',
      description: '내 글 : 정년정원 지원금 신청 후기~',
      pillText: '댓글',
      pillColor: '#ECEEF4',
      pillTextColor: '#8789A2',
    },
  ],
};

// Dataset for "북마크한 지원사업" (Bookmarked Support Programs)
export const bookmarkedSupportProgramsData = {
  title: '북마크한 지원사업',
  count: '3',
  icon: 'Bookmark',
  navigationRoute: '/naver/callmetellme/mypage/bookmarked-support-programs',
  postsData: [
    {
      id: 1,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '마감 5일',
      description: '최대 2,000만원',
      pillText: '지원금',
      pillColor: '#FFF08E',
      pillTextColor: '#D38C1B',
    },
    {
      id: 2,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '마감 5일',
      description: '최대 2,000만원',
      pillText: '지원금',
      pillColor: '#FFF08E',
      pillTextColor: '#D38C1B',
    },
    {
      id: 3,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '마감 5일',
      description: '최대 2,000만원',
      pillText: '지원금',
      pillColor: '#FFF08E',
      pillTextColor: '#D38C1B',
    },
  ],
};

// Dataset for "북마크한 게시글" (Bookmarked Posts)
export const bookmarkedPostsData = {
  title: '북마크한 게시글',
  count: '57',
  icon: 'Book',
  navigationRoute: '/naver/callmetellme/mypage/bookmarked-posts',
  postsData: [
    {
      id: 1,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '3일 전',
      description: '댓글 15',
      pillText: '커뮤니티',
      pillColor: '#ABF6AC',
      pillTextColor: '#0DA232',
      date: '2025.01.24',
      commentCount: 15,
      category: '커뮤니티',
      title: '청년 창업 지원금 프로그램',
      thumbnail: '/static/community/default-thumbnail.png',
      starCount: 12,
      likeCount: 8,
    },
    {
      id: 2,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '1주 전',
      description: '댓글 28',
      pillText: '커뮤니티',
      pillColor: '#ABF6AC',
      pillTextColor: '#0DA232',
      date: '2025.01.17',
      commentCount: 28,
      category: '커뮤니티',
      title: '청년 창업 지원금 프로그램',
      thumbnail: '/static/community/default-thumbnail.png',
      starCount: 25,
      likeCount: 18,
    },
  ],
};

// Dataset for "내가 쓴 게시글" (My Posts)
export const myPostsData = {
  title: '내가 쓴 게시글',
  count: '90',
  icon: 'SquarePen',
  navigationRoute: '/naver/callmetellme/mypage/my-posts',
  postsData: [
    {
      id: 1,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '3일 전',
      description: '조회수 143 댓글 15',
      pillText: '내 글',
      pillColor: '#ABD4F6',
      pillTextColor: '#3F68FF',
      date: '2025.01.24',
      commentCount: 15,
      category: '내 글',
      title: '청년 창업 지원금 프로그램',
      thumbnail: '/static/community/default-thumbnail.png',
      starCount: 12,
      likeCount: 8,
    },
    {
      id: 2,
      content: '청년 창업 지원금 프로그램',
      timeAgo: '1주 전',
      description: '조회수 143 댓글 28',
      pillText: '내 글',
      pillColor: '#ABD4F6',
      pillTextColor: '#3F68FF',
      date: '2025.01.17',
      commentCount: 28,
      category: '내 글',
      title: '청년 창업 지원금 프로그램',
      thumbnail: '/static/community/default-thumbnail.png',
      starCount: 25,
      likeCount: 18,
    },
  ],
};

// Dataset for "구독중인 상품" (Subscribed Products)
export const subscribedProductsData = {
  title: '구독중인 상품',
  count: '0',
  icon: 'CircleDollarSign',
  navigationRoute: '/naver/callmetellme/mypage/subscribed-products',
  postsData: [
    {
      id: 1,
      content: '프리미엄 지원사업 알림 서비스',
      timeAgo: '월 9,900원',
      description: '다음 결제: 2025.10.31',
      pillText: '프리미엄',
      pillColor: '#16D0B1',
      pillTextColor: '#FFFFFF',
    },
    {
      id: 2,
      content: '맞춤형 지원금 추천',
      timeAgo: '월 4,900원',
      description: '다음 결제: 2025.10.31',
      pillText: '베이직',
      pillColor: '#D07F16',
      pillTextColor: '#FFFFFF',
    },
    {
      id: 3,
      content: '커뮤니티 VIP 멤버십',
      timeAgo: '월 19,900원',
      description: '다음 결제: 2025.10.31',
      pillText: 'VIP',
      pillColor: '#BD16D0',
      pillTextColor: '#FFFFFF',
    },
    {
      id: 3,
      content: '커뮤니티 VIP 멤버십',
      timeAgo: '월 19,900원',
      description: '다음 결제: 2025.10.31',
      pillText: 'VIP',
      pillColor: '#BD16D0',
      pillTextColor: '#FFFFFF',
    },
  ],
};

// Dataset for "AI 추천 지원사업" (AI Recommended Support Programs)
export const aiRecommendedSupportProgramsData = {
  title: 'AI 추천 지원사업',
  count: '0',
  icon: 'Sparkles',
  navigationRoute: '/naver/callmetellme/mypage/ai-recommended-support-programs',
  postsData: [
    {
      id: 1,
      content: '2025년 여성창업 상세페이지 교육 및 컨설팅',
      timeAgo: '지원 금액 9,500만원',
      description: '신청 기간 25.01.06',
      pillText: '',
      pillColor: '#E3F2FD',
      pillTextColor: '#1976D2',
    },
    {
      id: 2,
      content: '2025년 여성창업 상세페이지 교육 및 컨설팅',
      timeAgo: '지원 금액 9,500만원',
      description: '신청 기간 25.01.06',
      pillText: '',
      pillColor: '#E3F2FD',
      pillTextColor: '#1976D2',
    },
    {
      id: 3,
      content: '2025년 여성창업 상세페이지 교육 및 컨설팅',
      timeAgo: '지원 금액 9,500만원',
      description: '신청 기간 25.01.06',
      pillText: '',
      pillColor: '#E3F2FD',
      pillTextColor: '#1976D2',
    },
  ],
};

// Dataset for "AI 추천 정책자금" (AI Recommended Policy Funds)
export const aiRecommendedPolicyFundsData = {
  title: 'AI 추천 정책자금',
  count: '0',
  icon: 'Sparkles',
  navigationRoute: '/naver/callmetellme/mypage/ai-recommended-policy-funds',
  postsData: [
    {
      id: 1,
      content: '2025년 여성창업 상세페이지 교육 및 컨설팅',
      timeAgo: '지원 금액 9,500만원',
      description: '신청 기간 25.01.06',
      pillText: '',
      pillColor: '#E3F2FD',
      pillTextColor: '#1976D2',
    },
    {
      id: 2,
      content: '2025년 여성창업 상세페이지 교육 및 컨설팅',
      timeAgo: '지원 금액 9,500만원',
      description: '신청 기간 25.01.06',
      pillText: '',
      pillColor: '#E3F2FD',
      pillTextColor: '#1976D2',
    },
    {
      id: 3,
      content: '2025년 여성창업 상세페이지 교육 및 컨설팅',
      timeAgo: '지원 금액 9,500만원',
      description: '신청 기간 25.01.06',
      pillText: '',
      pillColor: '#E3F2FD',
      pillTextColor: '#1976D2',
    },
  ],
};

// Combined export for easy access
export const mypageCardDatasets = {
  myComments: myCommentsData,
  repliesToMyComments: repliesToMyCommentsData,
  commentsOnMyPosts: commentsOnMyPostsData,
  bookmarkedSupportPrograms: bookmarkedSupportProgramsData,
  bookmarkedPosts: bookmarkedPostsData,
  myPosts: myPostsData,
  subscribedProducts: subscribedProductsData,
  aiRecommendedSupportPrograms: aiRecommendedSupportProgramsData,
  aiRecommendedPolicyFunds: aiRecommendedPolicyFundsData,
};
